/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_home = /** @type {(inputs: {}) => string} */ () => {
	return `Domů`
};

const da_home = /** @type {(inputs: {}) => string} */ () => {
	return `Hjem`
};

const de_home = /** @type {(inputs: {}) => string} */ () => {
	return `Startseite`
};

const en_home = /** @type {(inputs: {}) => string} */ () => {
	return `Home`
};

const es_home = /** @type {(inputs: {}) => string} */ () => {
	return `Inicio`
};

const fr_home = /** @type {(inputs: {}) => string} */ () => {
	return `Accueil`
};

const hu_home = /** @type {(inputs: {}) => string} */ () => {
	return `Kezdőlap`
};

const it_home = /** @type {(inputs: {}) => string} */ () => {
	return `Home`
};

const nl_home = /** @type {(inputs: {}) => string} */ () => {
	return `Home`
};

const pl_home = /** @type {(inputs: {}) => string} */ () => {
	return `Strona główna`
};

const pt_home = /** @type {(inputs: {}) => string} */ () => {
	return `Início`
};

const sv_home = /** @type {(inputs: {}) => string} */ () => {
	return `Hem`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home", locale)
	if (locale === "cs") return cs_home(inputs)
	if (locale === "da") return da_home(inputs)
	if (locale === "de") return de_home(inputs)
	if (locale === "en") return en_home(inputs)
	if (locale === "es") return es_home(inputs)
	if (locale === "fr") return fr_home(inputs)
	if (locale === "hu") return hu_home(inputs)
	if (locale === "it") return it_home(inputs)
	if (locale === "nl") return nl_home(inputs)
	if (locale === "pl") return pl_home(inputs)
	if (locale === "pt") return pt_home(inputs)
	return sv_home(inputs)
};